import { render } from "./OrderListView.vue?vue&type=template&id=4701e316&ts=true"
import script from "./OrderListView.vue?vue&type=script&lang=ts"
export * from "./OrderListView.vue?vue&type=script&lang=ts"

import "./OrderListView.vue?vue&type=style&index=0&id=4701e316&lang=postcss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__